var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":"currentColor","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M7.41,18.41L6,17L12,11L18,17L16.59,18.41L12,13.83L7.41,18.41M7.41,12.41L6,11L12,5L18,11L16.59,12.41L12,7.83L7.41,12.41Z"}},[_c('title',[_vm._v("Chevron Double Up icon")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }